import { appHttpService } from '@/services/standard/http-service';
import { models } from 'cesg-shared';

class AfterMarketService {
  async getAll(projectId: string): Promise<models.ListAfterMarketResponse> {
    return await appHttpService.request
      .url(`/after-market/${projectId}`)
      .get()
      .json<models.ListAfterMarketResponse>();
  }

  async replaceAll(
    projectId: string,
    rows: models.ReplaceAfterMarketBody,
  ): Promise<void> {
    await appHttpService.request
      .url(`/after-market/${projectId}`)
      .put(rows)
      .res();
  }
}

export const afterMarketService = new AfterMarketService();
